export default {
    "scalars": [
        0,
        1,
        4,
        7,
        11,
        13,
        18,
        19,
        20
    ],
    "types": {
        "Boolean": {},
        "Int": {},
        "LoginOutput": {
            "error": [
                4
            ],
            "token": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "PinOutput": {
            "token": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "String": {},
        "SubmissionIsolationPointsArrRelInsertInput": {
            "data": [
                8
            ],
            "onConflict": [
                10
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionIsolationPointsBoolExp": {
            "_and": [
                6
            ],
            "_not": [
                6
            ],
            "_or": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionIsolationPointsConstraint": {},
        "SubmissionIsolationPointsInsertInput": {
            "energyMagnitude": [
                19
            ],
            "energyMeasure": [
                4
            ],
            "energySource": [
                4
            ],
            "isolationDevice": [
                4
            ],
            "location": [
                4
            ],
            "number": [
                4
            ],
            "photo": [
                4
            ],
            "step": [
                1
            ],
            "submission": [
                16
            ],
            "submissionId": [
                1
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionIsolationPointsMutationResponse": {
            "affectedRows": [
                1
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionIsolationPointsOnConflict": {
            "constraint": [
                7
            ],
            "updateColumns": [
                11
            ],
            "where": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionIsolationPointsUpdateColumn": {},
        "SubmissionsBoolExp": {
            "_and": [
                12
            ],
            "_not": [
                12
            ],
            "_or": [
                12
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionsConstraint": {},
        "SubmissionsInsertInput": {
            "assetName": [
                4
            ],
            "assetPhoto": [
                4
            ],
            "assetSerial": [
                4
            ],
            "contactEmailAddress": [
                4
            ],
            "contactName": [
                4
            ],
            "contactPhone": [
                4
            ],
            "convertedOn": [
                20
            ],
            "isolationPoints": [
                5
            ],
            "notes": [
                4
            ],
            "site": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionsMutationResponse": {
            "affectedRows": [
                1
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionsObjRelInsertInput": {
            "data": [
                14
            ],
            "onConflict": [
                17
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionsOnConflict": {
            "constraint": [
                13
            ],
            "updateColumns": [
                18
            ],
            "where": [
                12
            ],
            "__typename": [
                4
            ]
        },
        "SubmissionsUpdateColumn": {},
        "numeric": {},
        "timestamptz": {},
        "Query": {
            "no_queries_available": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "Mutation": {
            "insertSubmissionIsolationPoints": [
                9,
                {
                    "objects": [
                        8,
                        "[SubmissionIsolationPointsInsertInput!]!"
                    ],
                    "onConflict": [
                        10
                    ]
                }
            ],
            "insertSubmissions": [
                15,
                {
                    "objects": [
                        14,
                        "[SubmissionsInsertInput!]!"
                    ],
                    "onConflict": [
                        17
                    ]
                }
            ],
            "login": [
                2,
                {
                    "emailAddress": [
                        4,
                        "String!"
                    ],
                    "password": [
                        4,
                        "String!"
                    ]
                }
            ],
            "pin": [
                3,
                {
                    "pin": [
                        4,
                        "String!"
                    ]
                }
            ],
            "__typename": [
                4
            ]
        }
    }
};
